import { render, staticRenderFns } from "./RetailSetupIssueModal.vue?vue&type=template&id=0e8cc1c2&"
import script from "./RetailSetupIssueModal.vue?vue&type=script&lang=js&"
export * from "./RetailSetupIssueModal.vue?vue&type=script&lang=js&"
import style0 from "../../styles/retail-setup-issue-modal.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports